/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";

import "swiper/css";
import { useTranslation } from "react-i18next";
import ProductTitleVideo from "./ProductTitleVideo";

import SimilarProductsDynamic from "../common/SimilarProductsDynamic";

function SiviElSabunu() {
const [activeIndex, setActiveIndex] = useState(0);

const handleSelect = (selectedIndex) => {
setActiveIndex(selectedIndex);
};

const handlePrev = () => {
handleSelect(activeIndex === 0 ? 5 : activeIndex - 1);
};

const handleNext = () => {
handleSelect(activeIndex === 5 ? 0 : activeIndex + 1);
};

const { t } = useTranslation();
const [expanded, setExpanded] = useState(false);

const toggleNav = () => {
setExpanded(!expanded);
};

const handleClick = () => {
window.scrollTo(0, 0);
setExpanded(false);
};

const customProducts = [
{
picture: "assets/images/20-kg/11.webp",
title: "Sıvı El Sabunu (Mavi)",
nav: "/sivielsabunumavi"
},
{
picture: "assets/images/20-kg/12.webp",
title: "Sıvı El Köpük",
nav: "/sivielkopuk"
}
];

return (
<>
    <SRLWrapper>
        <section class="product-details section-space">
            <div class="container">
                <div class="row gutter-y-50">
                    <div class="col-lg-6 col-xl-6 wow fadeInLeft" data-wow-delay="200ms">
                        <div class="product-details__img">
                            <div class="swiper product-details__gallery-top p-5">
                                <div className="album-list-item">
                                    <Link className="ali-link" onClick={handleClick} as={Link} to="/Armur">
                                    <div className="ali-img-wrap">
                                        <div>
                                            <img className="img-fluid blur-up lazyload"
                                                src="assets/images/20-kg/15.webp" alt="Sıvı El Sabunu"
                                                title="Sıvı El Sabunu" />
                                        </div>
                                    </div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-xl-6 wow fadeInRight" data-wow-delay="300ms">
                        <div class="product-details__content">
                            <div
                                style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px'}}>
                                <ProductTitleVideo title="Sıvı El Sabunu" video="" />
                                <span className="product-details__weight"
                                    style={{fontSize: '16px', fontWeight: 'bold', color: '#10adad'}}>
                                    5 KG - 20 KG
                                </span>
                            </div>
                            <div class="product-details__excerpt">
                                <h4 class="mt-4 mb-3">ÖZELLİKLERİ</h4>
                                <ul class="product-details__list">
                                    <li>Bol köpüklüdür. Cilt pH'ına uygundur.</li>
                                    <li>Dermatolojik olarak güvenlidir.</li>
                                    <li>Hoş kokulu dur.</li>
                                    <li>Mamul içindeki aktif maddeler %80 oranında biyolojik olarak parçalanabilir.</li>
                                    <li>Otellerde, motellerde, restoranlarda ve tüm işletmelerde el temizliğinde
                                        kullanılır.</li>
                                </ul>

                                <h4 class="mt-4 mb-3">KULLANIM ŞEKLİ VE MİKTARI</h4>
                                <ul class="product-details__list">
                                    <li>Sıvı sabun aparatları ve diletleri ile kullanılır.</li>
                                    <li>Aparattan birkaç basma, yeter miktarda sıvı sabun avuç içine alınır.</li>
                                    <li>Eller ıslatılarak bir süre ovuşturulur ve bol su ile durulanır.</li>
                                    <li>Ortak kullanımı hijyenik ve ekonomik olmayan kalıp sabun yerine kullanılır.
                                    </li>
                                </ul>
                            </div>

                            <div class="product-details__buttons">
                                <Link as={Link} to="/urunlerimiz" class="product-details__btn boskery-btn">
                                <span class="boskery-btn__hover"></span>
                                <span class="boskery-btn__hover"></span>
                                <span class="boskery-btn__hover"></span>
                                <span class="boskery-btn__hover"></span>
                                <span class="boskery-btn__hover"></span>
                                <span class="boskery-btn__hover"></span>
                                <span class="boskery-btn__text">
                                    {" "}
                                    DİĞER ÜRÜNLERİMİZ
                                </span>
                                <i class="icon-arrow-right"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="product-details__description-wrapper">
                <div class="container">
                    <div class="product-details__description">
                        <h3 class="product-details__description__title">
                            Ürün Detayları
                        </h3>
                        <div class="product-details__text__box wow fadeInUp" data-wow-delay="300ms">

                            <h4 class="mt-4 mb-3">ÜRÜN BİLEŞİMİ</h4>
                            <div class="table-responsive">
                                <p>
                                    Anyonik aktif madde %5-15, nonİyonik aktif madde %5, ayrıca sedef,
                                    gliserin, boya, koruyucu ve esans içerir.
                                </p>
                            </div>

                            <div class="alert alert-info mt-4 p-4 text-white" style={{ backgroundColor: "#10adad" }}>
                                <h6><strong>TÜKETİCİNİN DİKKATİNE :</strong></h6>
                                <ul class="mb-0">
                                    <li>Kullanma talimatını mutlaka okuyunuz.</li>
                                    <li>Orijinal ambalajında kapalı şekilde ve yüksek sıcaklıktan uzak olarak
                                        saklayınız.</li>
                                    <li>(-5 °C'den ve +40 °C'den yüksek sıcaklıklarda saklamayınız.)</li>
                                    <li>Kapakta bulunan emniyet pimi kırılmış bidonları satın almayınız.</li>
                                    <li>Çocuklardan uzak tutunuz.</li>
                                    <li>Dexpur, yanlış kullanım ve saklamadan doğacak zarardan sorumlu
                                        değildir.</li>
                                </ul>
                            </div>

                            <div class="danger-warnings mt-4 p-3 bg-danger text-white">
                                <h6><strong>⚠️ ZEHİRLENME DURUMUNDA:</strong></h6>
                                <div class="alert alert-light mt-3 mb-3 text-dark">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <p class="mb-1"><strong>114'ü</strong></p>
                                            <p class="mb-0 small">ULUSAL ZEHİR DANIŞMA MERKEZİ</p>
                                        </div>
                                        <div class="col-md-6">
                                            <p class="mb-1"><strong>112'yi</strong></p>
                                            <p class="mb-0 small">ACİL SAĞLIK HİZMETLERİ</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="alert alert-warning mt-3 mb-0">
                                    <p class="mb-0">
                                        <strong>⚠️ DİKKAT :</strong> Üretim tarihi, son kullanma tarihi ile parti no ve
                                        seri no, ambalajın üzerindedir.
                                    </p>
                                </div>
                            </div>

                            <div class="product-info-box mt-4 p-3 bg-light">
                                <h6><strong>📋 TEKNİK BİLGİLER:</strong></h6>
                                <div class="row">
                                    <p><strong>Net Ağırlık:</strong> 5 KG ve 20 KG Seçenekleri mevcuttur.</p>
                                    <p><strong>Üretici Firma :</strong> Seymen Kimya Temizlik San. ve Tic. Ltd. Şti.</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    </SRLWrapper>

    <SimilarProductsDynamic products={customProducts} handleClick={handleClick} />
</>
);
}

export default SiviElSabunu;